/**
 * @description: 用户管理路由文件
 * @author: lx
 * @Compile：2022-06-02 10：00
 * @update: lx(2022-06-02 10：00)
 */
export default [
  {
    path: "/sysconfig",
    component: () => import("../../pages/lookfor/sysconfig/sysconfig.vue"),
    name: "userInfo",
    title: "系统参数配置",
    meta: {
      title: "系统参数配置"
    }
  },
]
